import { Navigate } from 'react-router-dom';
import type { RouteObject } from 'react-router-dom';

import CustomerLayout from '../../layouts/customerLayout';
import { FEATURE_ROUTES } from '../routeConstants';
import {
  childPath,
  ComingSoonPage,
  CustomerPage,
  ShopPageRoute,
  ProductPage,
  CustomerCardSetupPage,
  ForbiddenPage,
  HomePage,
  OrderTrackingPage,
  PaymentCancelPage,
  PaymentResultPage,
  PaymentSuccessPage,
  PrivacyPage,
  RefundsPage,
  ResetPasswordPage,
  route,
  ScannerPage,
  SharedStatusPage,
  SignUpPage,
  StorePolicyPage,
  TermsPage,
  CodeOfConductPage,
  VerifyEmailPage,
  CheckoutPage,
  ApproveTeenLinkPage,
  SupportPage,
  AboutPage,
  HowItWorksPage,
  FaqPage,
  BottleReturnsPage
} from './routeCommon';

export const customerManifestRoutes: RouteObject[] = [
  { path: childPath(FEATURE_ROUTES.auth.forbidden), element: route(<ForbiddenPage />) },
  {
    element: <CustomerLayout />,
    children: [
      { index: true, element: route(<HomePage />) },
      {
        path: childPath(FEATURE_ROUTES.customer.portal),
        element: <Navigate to={FEATURE_ROUTES.customer.account} replace />
      },
      {
        path: childPath(FEATURE_ROUTES.customer.legacyShopper),
        element: <Navigate to={FEATURE_ROUTES.customer.shop} replace />
      },
      {
        path: childPath(FEATURE_ROUTES.customer.catalog),
        element: <Navigate to={FEATURE_ROUTES.customer.shop} replace />
      },
      {
        path: childPath(FEATURE_ROUTES.customer.products),
        element: <Navigate to={FEATURE_ROUTES.customer.shop} replace />
      },
      { path: childPath(FEATURE_ROUTES.customer.cardSetup), element: route(<CustomerCardSetupPage />) },
      { path: childPath(FEATURE_ROUTES.customer.shop), element: route(<ShopPageRoute />) },
      { path: childPath(FEATURE_ROUTES.customer.product), element: route(<ProductPage />) },
      { path: childPath(FEATURE_ROUTES.customer.account), element: route(<CustomerPage />) },
      { path: childPath(FEATURE_ROUTES.customer.storeComingSoon), element: route(<ComingSoonPage />) },
      { path: childPath(FEATURE_ROUTES.payments.success), element: route(<PaymentSuccessPage />) },
      { path: childPath(FEATURE_ROUTES.payments.cancel), element: route(<PaymentCancelPage />) },
      { path: childPath(FEATURE_ROUTES.payments.result), element: route(<PaymentResultPage />) },
      { path: childPath(FEATURE_ROUTES.auth.resetPassword), element: route(<ResetPasswordPage />) },
      { path: childPath(FEATURE_ROUTES.auth.verifyEmail), element: route(<VerifyEmailPage />) },
      { path: childPath(FEATURE_ROUTES.auth.signUp), element: route(<SignUpPage />) },
      { path: childPath(FEATURE_ROUTES.auth.approveTeenLink), element: route(<ApproveTeenLinkPage />) },
      { path: childPath(FEATURE_ROUTES.legal.privacy), element: route(<PrivacyPage />) },
      { path: childPath(FEATURE_ROUTES.legal.refunds), element: route(<RefundsPage />) },
      { path: childPath(FEATURE_ROUTES.legal.storePolicy), element: route(<StorePolicyPage />) },
      { path: childPath(FEATURE_ROUTES.legal.terms), element: route(<TermsPage />) },
      { path: childPath(FEATURE_ROUTES.legal.codeOfConduct), element: route(<CodeOfConductPage />) },
      { path: childPath(FEATURE_ROUTES.legal.about), element: route(<AboutPage />) },
      { path: childPath(FEATURE_ROUTES.legal.howItWorks), element: route(<HowItWorksPage />) },
      { path: childPath(FEATURE_ROUTES.legal.faq), element: route(<FaqPage />) },
      { path: childPath(FEATURE_ROUTES.legal.bottleReturns), element: route(<BottleReturnsPage />) },
      { path: childPath(FEATURE_ROUTES.tools.scannerEligibility), element: route(<ScannerPage />) },
      { path: childPath(FEATURE_ROUTES.tools.sharedStatus), element: route(<SharedStatusPage />) },
      { path: childPath(FEATURE_ROUTES.customer.orderTracking), element: route(<OrderTrackingPage />) },
      { path: childPath(FEATURE_ROUTES.customer.cart), element: <Navigate to="/shop?cart=open" replace /> },
      { path: childPath(FEATURE_ROUTES.customer.checkout), element: route(<CheckoutPage />) },
      { path: childPath(FEATURE_ROUTES.customer.support), element: route(<SupportPage />) },
      { path: childPath(FEATURE_ROUTES.customer.contact), element: route(<SupportPage />) }
    ]
  },
  { path: '*', element: <Navigate to="/" replace /> }
];
